module.exports = __webpack_public_path__ + "img/class4.885f2f39.png";